import { CreateGUFClosureTask, EditGUFClosureTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGufLibraryFields } from "./guf-schema-library";

const sharedTitle = (type: FormType | undefined) => `GUF Beëindigen ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het GUF beëindigen formulier. ${getDocsLinkMarkdown("GUF")}`;

const sharedSourcedocumentData = {
  type: "object" as const,
  title: "Brondocumentgegevens",
  required: ["endTime"],
  properties: pickGufLibraryFields(["endTime"]),
};

const getGufClosureCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<CreateGUFClosureTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: ["projectNumber", "deliveryAccountableParty", "qualityRegime", "broId"],
      properties: pickGufLibraryFields([
        "projectNumber",
        "qualityRegime",
        "deliveryAccountableParty",
        "broId",
      ]),
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

const getGufClosureEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditGUFClosureTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: [
        "projectNumber",
        "deliveryAccountableParty",
        "qualityRegime",
        "broId",
        "correctionReason",
      ],
      properties: {
        ...pickGufLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGufLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

export function getGufClosureSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditGUFClosureTask>;
export function getGufClosureSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<CreateGUFClosureTask>;
export function getGufClosureSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}): SchemaForFormData<EditGUFClosureTask> | SchemaForFormData<CreateGUFClosureTask>;
export function getGufClosureSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing ? getGufClosureEditSchema(type) : getGufClosureCreateSchema(type);
}
